import React from 'react';

import {
	ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE,
	LazyImportSpacesPage,
} from '@confluence/site-settings';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminImportSpacesRoute = () => <LazyImportSpacesPage />;

AdminImportSpacesRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
